/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding initialization code.
 * Use "quasar new plugin <name>" and add it there.
 * One plugin per concern. Then reference the file(s) in quasar.conf.js > plugins:
 * plugins: ['file', ...] // do not add ".js" extension to it.
 **/


import Vue from 'vue'
import Quasar, {QLayout,QLayoutHeader,QLayoutFooter,QLayoutDrawer,QPageContainer,QPageSticky,QPage,QPopover,QCard,QCardMain,QChip,QChipsInput,QCollapsible,QEditor,QTree,QToolbar,QToolbarTitle,QBtn,QBtnToggle,QModal,QModalLayout,QField,QInput,QIcon,QList,QListHeader,QItem,QItemMain,QItemSide,QItemTile,QBtnDropdown,QResizeObservable,QSlider,QSpinnerHourglass,QSpinnerDots,QSpinnerGears,QInnerLoading,QFab,QFabAction,QTooltip,QCheckbox,QOptionGroup,QAutocomplete,QDatetime,QSelect,Ripple,CloseOverlay,BackToTop,TouchSwipe,TouchHold,Notify,Dialog,Loading,ActionSheet} from 'quasar'

Vue.use(Quasar, {components: {QLayout,QLayoutHeader,QLayoutFooter,QLayoutDrawer,QPageContainer,QPageSticky,QPage,QPopover,QCard,QCardMain,QChip,QChipsInput,QCollapsible,QEditor,QTree,QToolbar,QToolbarTitle,QBtn,QBtnToggle,QModal,QModalLayout,QField,QInput,QIcon,QList,QListHeader,QItem,QItemMain,QItemSide,QItemTile,QBtnDropdown,QResizeObservable,QSlider,QSpinnerHourglass,QSpinnerDots,QSpinnerGears,QInnerLoading,QFab,QFabAction,QTooltip,QCheckbox,QOptionGroup,QAutocomplete,QDatetime,QSelect},directives: {Ripple,CloseOverlay,BackToTop,TouchSwipe,TouchHold},plugins: {Notify,Dialog,Loading,ActionSheet}})



//////////////////
// WEBPACK FOOTER
// ./.quasar/quasar.js
// module id = null
// module chunks = 